<template>
  <div class="contentbox">
    <div class="media-add-video-list">
      <div class="exit-status">
        <table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
          <tbody>
            <tr>
              <th>功能</th>
              <th>状态</th>
              <th>配置</th>
            </tr>
            <tr>
              <td>播放页退出推荐剧配置</td>
              <td width="300" >
                <el-switch v-model="exitRecomStatus" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="handleRecomOpen"></el-switch>
              </td>
              <td>
                <el-select v-model="configType" placeholder="请选择配置" clearable @change="handleConfigType">
                  <el-option v-for="item in configTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="select-video-btn">
        <el-button type="success" icon="el-icon-star-on" size="small" @click="isShowDialogVideo = true">自推荐配置</el-button>
        <span class="tips">自推荐下，剧配置数量≥6，否则默认平台推荐剧兜底</span>
      </div>
      <div class="tableTh" v-height>
        <el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle">
          <el-table-column prop="" label="序号" width="60" fixed>
            <template slot-scope="scope">
              <span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="短剧信息" width="260">
            <template slot-scope="scope">
              <div class="td-info">
                <p>短剧名：{{ scope.row.svName }}</p>
                <p>别名：{{ scope.row.aliasName }}</p>
                <p>短剧ID：{{ scope.row.svId }}</p>
                <p>剧目ID：{{ scope.row.albumId }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="剧集信息" width="200">
            <template slot-scope="scope">
              <div class="td-info">
                <p>总集数：{{ scope.row.sumEps }}</p>
                <p>更新集数：{{ scope.row.upEps }}</p>
                <p>是否完结：{{ scope.row.writingStatus == 0 ? '未完结' : '完结' }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="封面" width="130">
            <template slot-scope="scope">
              <img class="cover" :src="scope.row.coverPath" />
            </template>
          </el-table-column>
          <el-table-column label="解锁剧集信息" width="200">
            <template slot-scope="scope">
              <div class="td-info">
                <p>免费集数：{{ scope.row.userFreeEp }}</p>
                <p>每集金币数：{{ scope.row.epPrice }}</p>
                <p>解锁模式：
                  <span v-if="scope.row.priceFlag == 0">纯付费解锁</span>
									<span v-if="scope.row.priceFlag == 2">纯广告解锁</span>
									<span v-if="scope.row.priceFlag == 3">单集付费+广告解锁</span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="videoAbility" label="状态">
            <template slot-scope="scope">
              <div class="td-info">
                <p v-if="scope.row.rackStatus == 0" class="danger-text">已下架</p>
                <p v-if="scope.row.rackStatus == 1" class="succes-text">上架中</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sortNo" label="排序" width="160">
            <template slot-scope="scope">
              <div class="td-info">
                <el-input-number v-model="scope.row.sortNo" :min="1" :step="1" controls-position="right" style="width: 100px;" @change="changeSortNo(scope.row)"></el-input-number>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope" class="ddd">
              <el-popover v-has="'mediaAddVideo:delete'" width="160" :ref="scope.row.id" style="margin-left: 10px;">
                <p class="popover-con del">
                  <i class="el-icon-question warnning-text"></i>确定删除吗？
                </p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
                  <el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>
                </div>
                <el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">删除</el-button>
              </el-popover>

            </template>
          </el-table-column>
        </el-table>
        <div class="foot-table" style="text-align:center;">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background :current-page="currentPage"
            layout="sizes, prev, pager, next, jumper, ->, total" :total="tableData.totalNum">
          </el-pagination>
        </div>
      </div>
    </div>
    <binge-video-table :visible.sync="isShowDialogVideo" :appId="formInline.appId" @videoSure="videoSure"
    @cancelDialogVideo="cancelDialogVideo"> </binge-video-table >
  </div>
</template>
<script>
import BingeVideoTable from '@/components/BingeVideoTable'
export default {
  components: {
		BingeVideoTable,
	},
  data() {
    return {
      appId: localStorage.getItem('appId'),
      formInline: {
        appId: localStorage.getItem('appId'),
      },
      tableData: {
        pageSize: 20,
        pageNo: 1,
        totalPage: 1,
        totalNum: 0,
        result: []
      },
      exitRecomConfig:[{}],
      exitRecomStatus:0,
      currentPage: 1,
      isShowDialogVideo: false,
      selectVideo: [],
      configType:2,
      configTypeOptions:[
        {
					value: 1,
					label: '平台推荐'
				},
				{
					value: 2,
					label: '自推荐'
				}
      ],
    }
  },
  computed: {},
  watch: {
  },
  mounted: function () {
    this.getTableData()
    // after_recommend_1  状态   after_recommend_2  推荐配置
    this.getKeyStatus('after_recommend_1')
    this.getKeyStatus('after_recommend_2')
  },
  methods: {
    handleCurrentChange(value) {
      this.currentPage = value
      this.getTableData()
    },
    // pageSize切换
    handleSizeChange(val) {
      this.tableData.pageSize = val
      this.currentPage = 1
      this.getTableData()
    },
    // 删除
    handleDelete(id) {
      console.log(id,"删除")
      this.axios({
        method: 'get',
        url: '/video/videoRecommendModule/delete',
        params: {
          infoId:id
        }
      }).then((response) => {
        if (response.data.head.flag === 0) {
          this.$message.success("删除成功！")
          this.getTableData()
        } else {
          this.$message.error(response.data.head.desc)
        }
      })
    },
   
    getTableData() {
      console.log("获取列表信息")
      this.axios({
        method: 'get',
        url: '/video/videoRecommendModule/getList',
        params: {
          pageNo:this.currentPage,
          pageSize:this.tableData.pageSize,
        }
      }).then((response) => {
        if (response.data.head.flag === 0) {
          this.tableData = response.data.content
          console.log("getTableData",this.tableData)
        } else {
          this.$message.error(response.data.head.desc)
        }
      })
    },
    // 获取推荐状态
    getKeyStatus(type){
      this.axios({
        method: 'get',
        url: '/video/videoRecommendModule/getKeyStatus',
        params: {
          keywords: type,
        }
      }).then((response) => {
        if (response.data.head.flag === 0) {
          if(type == 'after_recommend_2'){
            this.configType = response.data.content || 1
          }else{
            this.exitRecomStatus = response.data.content || 0
          }
        } else {
          this.$message.error(response.data.head.desc)
        }
      })
    },
    //改变推荐状态
    handleRecomOpen(val){
      this.axios({
        method: 'get',
        url: '/video/videoRecommendModule/updateKeyStatus',
        params: {
          keywords:'after_recommend_1',
          status:val
        }
      }).then((response) => {
        if (response.data.head.flag === 0) {
          this.getKeyStatus('after_recommend_1')
        } else {
          this.$message.error(response.data.head.desc)
        }
      })
    },
    //切换推荐配置
    handleConfigType(val){
      this.axios({
        method: 'get',
        url: '/video/videoRecommendModule/updateKeyStatus',
        params: {
          keywords:'after_recommend_2',
          status:val
        }
      }).then((response) => {
        if (response.data.head.flag === 0) {
          this.getKeyStatus('after_recommend_2')
        } else {
          this.$message.error(response.data.head.desc)
        }
      })
    },

    // 选定自推荐的剧
		videoSure(data) {
      this.selectVideo = data
      const svIds = data.videoList
      const list = svIds.map((item,index) => {
        let sortNo = 1
        if(this.tableData.result.length > 0){
          sortNo = this.tableData.totalNum + index + 1
        }else{
          sortNo = index + 1
        }
        return {
          id:'',
          sortNo: sortNo,
          svId:item,
          type:1
        }
      })
      console.log("选定自推荐的剧",list)
      this.axios({
        method: 'post',
        url: '/video/videoRecommendModule/addInfo',
        data: list
      }).then((response) => {
        if (response.data.head.flag === 0) {
          console.log("添加成功",response.data)
          this.$message.success("自推荐配置成功！")
          this.getTableData()
        } else {
          this.$message.error(response.data.head.desc)
        }
      })
		},
    // 关闭选剧弹窗
		cancelDialogVideo(data) {
			this.isShowDialogVideo = data
		},
    // 排序改变时
    changeSortNo(row){
      console.log("排序改变时---",row)
      this.axios({
        method: 'post',
        url: '/video/videoRecommendModule/addInfo',
        data: [{
          id:row.id,
          sortNo:row.sortNo,
          svId:row.svId,
          type:1
        }]
      }).then((response) => {
        if (response.data.head.flag === 0) {
          this.getTableData()
        } else {
          this.$message.error(response.data.head.desc)
        }
      })

    },

  }
}
</script>
<style scoped lang="scss">
.exit-status{
  box-sizing: border-box;
  th{
    background-color: #f2f2f2;
    padding: 12px;
  }
  
}
.select-video-btn{
  margin: 20px 0;
  .tips{
    color: #b0b0b0;
    font-size: 12px;
    margin-left: 10px;
  }
}
</style>
